/* eslint-disable import/no-named-as-default */
/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import HeroV2 from '../components/Home/HeroV2';
import WhiteCTA from '../components/CTAs/WhiteCTA';
import FAQV2 from '../components/text/FAQ/faqV2';
import BlackCTA from '../components/CTAs/BlackCTA';
import CommunityCarousel from '../components/Carousels/CommunityCarousel';
import PTNews from '../components/CardSections/PTNews';
import MissionStatement from '../components/Home/MissionStatement';
import TopRankings from '../components/ProTennisPage/PtsRankingList';
// eslint-disable-next-line import/no-named-as-default
import UpcomingEvents from '../components/Tables/UpcomingEvents';
import RecentResults from '../components/CardSections/RecentResults';

import * as homepageActions from '../redux/actions/homepage-actions';
import * as resourceActions from '../redux/actions/resource-actions';
import { fetchPtsEventsV2 } from '../redux/actions/event-actions';
import { fetchPtsRankings } from '../redux/actions/pts-ranking-actions';
import { getProTennisPageContent } from '../redux/actions/v2/pro-tennis-page-actions';

import RenderPrismicContent from '../components/RenderPrismicContent';
import { getBackgroundClass } from '../utils/styling';

import styles from './pro-tennis.module.scss';

const ProTennisPageV2 = (props) => {
    console.log('proTennisPage props', props);
    const { proTennisPageV2 } = props;

    return (
        <div className={`${styles.proTennisPage} ${getBackgroundClass(proTennisPageV2.content)}`}>
            <RenderPrismicContent contentSlices={proTennisPageV2.content} />
        </div>
    );
};

ProTennisPageV2.getInitialProps = async ({ store, query }) => {
    const { homepage, resources, events, ptsRankings, proTennisPageV2 } = store.getState();
    if (!(homepage && homepage.homepageContentLoaded)) {
        await store.dispatch(homepageActions.fetchHomepageContent());
    }
    if (!(resources?.resourceContent?.players)) {
        await store.dispatch(resourceActions.fetchResourceContent());
    }
    if (!(events && events.ptsEventsLoaded)) {
        await store.dispatch(fetchPtsEventsV2({
            start: moment.utc(moment()).format('MM/DD/YYYY'),
            end: moment.utc(moment()).endOf('month').format('MM/DD/YYYY'),
        }));
    }
    if (!(ptsRankings && ptsRankings.isLoaded)) {
        await store.dispatch(fetchPtsRankings('m', 10, 0));
    }
    if (!(proTennisPageV2 && proTennisPageV2.loaded)) {
        await store.dispatch(getProTennisPageContent());
    }
    return { query };
};

function mapStateToProps({ homepage, resources, events, ptsRankings, proTennisPageV2 }) {
    return { homepage, resources, events, ptsRankings, proTennisPageV2 };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchHomepageContent: (token) => {
            dispatch(homepageActions.fetchHomepageContent(token));
        },
        fetchPtsRankings: (gender, top, skip) => {
            dispatch(fetchPtsRankings(gender, top, skip));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProTennisPageV2);
